export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-noticebar/index.js